import resume from "../assets/pdf/resume.pdf";

export const headerData = {
  name: "Gaurav Pathak",
  title: "Software Developer",
  desciption:
    "Crafting solutions that work silently behind the scenes, delivering smooth and reliable experiences",
  image: "https://ca.slack-edge.com/T04HQRK7TPX-U05LD4RGRDH-601122558f63-512",
  resumePdf: resume,
};
